


































































import { Component, Vue } from "vue-property-decorator";
import { FriendRef } from "@dokogd/shared";
import { api } from "../../store/modules/friends";
import { Getter } from "vuex-class";
import FriendSelect from "../widgets/FriendSelect.vue";
import { typeIsNotNone } from "../../utils";

@Component({ components: { FriendSelect } })
export default class DeskCompilation extends Vue {
  seats: (null | FriendRef)[] = [null, null, null, null, null, null];
  activeSeat = -1;

  @Getter(api.getters.getFriends, { namespace: api.namespace })
  list!: FriendRef[];

  setFriendOnSeat(friend: FriendRef) {
    this.$set(this.seats, this.activeSeat, friend);
    this.activeSeat = -1;
    this.emitChange();
  }

  activateSeat(idx: number) {
    if (this.seats[idx] === null) {
      this.activeSeat = idx;
    } else {
      this.$set(this.seats, idx, null);
      this.activeSeat = -1;
    }
    this.emitChange();
  }

  get ignoreIds() {
    return this.seats.filter(typeIsNotNone).map((seat) => seat.id);
  }

  emitChange() {
    this.$emit("change", this.seats.filter(typeIsNotNone));
  }
}
